import { UrlUtil } from "@core/utils";
import { envConfig } from "@env/env-config";
import type { IPageObjectTreeService } from "@modules/basic/page";
import type { IPermissionService } from "@modules/basic/page/page-service";
import { DefaultCatalogUtil } from "@modules/catalog/default-catalog-util";
import type { IProductCatalog, productCatalogWithPagePath } from "@modules/catalog/product-catalog/model/domain/ProductCatalog";
import type { IProductCatalogRestService } from "@modules/catalog/product-catalog/rest/product-catalog-rest";
import type { PreferenceEditorResolveDefine } from "@modules/partner/model/domain/preference";
import type { IPreferenceEditorService } from "@components/preference-editor/preference-editor.service";
import type { IEventBus } from "@core/event-bus/event-bus";
import type { ICurrencyObj } from "./header";
import type { IMessageDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.interface";
import type { IUserDataService } from "@modules/user/service/data/i-user-data-service";
import type { CurrencyCodeType } from "@modules/website/model/domain/currency";
import { LocalStorageKeyEnum } from "../LocalStorageKeyEnum";

export class NavDrawerController {

    public static $inject: Array<string> = [
        "$scope", "pageContext", "$timeout",
        "$window", "$objectTree", "productCatalogRestService",
        "$filter", "$q", "permissionService",
        "$translate", "$uibModal", "preferenceEditorService",
        "eventBus", "qpMessageDialog", "userDataService"
    ]
    // 当前激活的导航项id
    public activeMenuItem: string;
    // 父级导航项id
    public parentMenuItem: string;
    // 父级导航项名称
    public lastMenuName: string;
    // 是否登录
    public islogin: boolean;

    // appPath路径
    public appPath: string;

    public readonly rootPath: string;

    public qpmnDomain: string;

    private homePage: string;

    public productCatalogList;
    public isFetchedCatalogData: boolean = false;

    public catalogTemp;

    private defaultCatalogUrl: string;
    private defaultCatalogName: string;
    // 产品分类__缓存15分钟 
    private CATALOG_CACHE_TIME: number = 900 * 1000; // (转换为ms)
    // 当前导航类型
    private activeMenuType: string | null;
    private catalogListUrl: string;
    public get preferenceCurrencyCodeViewer(): CurrencyCodeType | "" {
        if (this.preferenceEditorService.userPreference.currencyCode) {
            return "(" + this.preferenceEditorService.userPreference.currencyCode + ")";
        } else {
            return "";
        }
    }
    constructor(
        public $scope: angular.IScope,
        public pageContext: qpmn.main.IPageContext,
        public $timeout: angular.ITimeoutService,
        public $window: angular.IWindowService,
        public $objectTree: IPageObjectTreeService,
        public productCatalogRestService: IProductCatalogRestService,
        public $filter: angular.IFilterService,
        public $q: angular.IQService,
        public permissionService: IPermissionService,
        public $translate: angular.translate.ITranslateService,
        public $uibModal: angular.ui.bootstrap.IModalService,
        public preferenceEditorService: IPreferenceEditorService,
        public eventBus: IEventBus,
        public qpMessageDialog: IMessageDialog,
        public userDataService: IUserDataService
    ) {
        this.activeMenuItem = "0";
        this.activeMenuType = "Catalog";

        this.appPath = envConfig.appPath();

        this.rootPath = this.pageContext.rootPath;
        this.homePage = envConfig.getHomePage(this.rootPath);
        this.qpmnDomain = envConfig.getPath("", "");
        // 设置普通页面catalog-list模板地址
        this.catalogListUrl = this.rootPath + "menu-mobile/index.html";
        this.$objectTree.setUserDataService(this.userDataService);
    }


    /**
    * @description 切换菜单
    * @param currentItem 
    * @param parentItem 
    * @param navType
    */
    public changeMenu(currentItem: string, parentItem: string, navType?: string) {
        this.$timeout(() => {
            this.$scope.$apply(() => {
                if (navType) {
                    this.activeMenuType = navType;
                } else {
                    this.activeMenuType = null;
                }
                this.activeMenuItem = currentItem;
                this.parentMenuItem = parentItem;
                this.lastMenuName = $("#" + this.activeMenuItem).attr("name") as string;
            });
        }, 100);
    }

    public menuBack() {
        let _pid = this.parentMenuItem;
        this.activeMenuItem = _pid;
        this.parentMenuItem = _pid != "0" ? $("#" + this.activeMenuItem).attr("pid") as string : "0";
        this.lastMenuName = _pid != "0" ? $("#" + _pid).attr("name") as string : "";
    }

    public logIn() {
        this.$window.location.href = this.pageContext.rootPath + "partner/login/" + "?" + encodeURIComponent(location.href);
    }

    public $onInit() {
        if (!this.$objectTree.isAnonymous()) {
            this.islogin = false
        } else {
            this.islogin = true
        }
        this.setMenuWatch();
    }

    /**
     * @description:判断是否有产品类目的缓存，有直接取缓存，没有则重新请求
     */
    private setMenuWatch() {

        let expireT = this.$objectTree.getCache(LocalStorageKeyEnum.CATALOG_LIST_EXPIRE);
        let expireTime: number = 0;

        if (expireT != null) {
            expireTime = Number(expireT);
        }
        // 获取产品类目
        // let list = this.$objectTree.getCache("CatalogList");
        // // 获取默认类目
        // const defaultCatalog = this.$objectTree.getCache("DefaultCatalog");
        // if (expireTime < new Date().getTime() || !list || !defaultCatalog) {
        //     this.fetchProductCatalogData();
        // } else {
        //     if (list) {
        //         this.productCatalogList = angular.fromJson(list);
        //     }
        //     if (defaultCatalog) {
        //         // 设置默认类目信息
        //         DefaultCatalogUtil.getDefaultCatalog(this.$objectTree, this.$q)
        //             .then((res) => {
        //                 this.defaultCatalogUrl = UrlUtil.joinUrl([this.pageContext.rootPath, res.customizePath, (res.defaultCatalog as productCatalogWithPagePath).pagePath]);
        //                 this.defaultCatalogName = res.defaultCatalog.name;
        //             }, error => {
        //                 this.permissionService.onRequestFail(error?.currentTarget);
        //             })
        //     }
        // }
    }

    // 页面跳转
    public menuJumpPage(url?: string) {
        let _url = url || "";
        this.$window.location.href = this.pageContext.rootPath + _url;

    }
    /**
     * @description 获取注册页面地址
     * */
    public getRegistUrl(): string {
        return this.pageContext.rootPath + 'partner/regist/' + "?" + encodeURIComponent(location.href);
    }
    /**
     * @description 获取ng2App页面地址
     * @params path
     * */
    public getNg2AppPageUrl(path: string): string {
        const ng2App = envConfig.appPath('ng2App');
        const pageUrl = UrlUtil.joinUrl([ng2App, path]);
        return pageUrl;
    }

    /**
     * @description 退出登录
     */
    public signOut() {
        // 清除登录缓存
        this.$objectTree.clearLogin();

        // if (this.$objectTree.isAnonymous()) {
        //     // 刷新当前页面
        //     window.location.reload();
        // } else {
        //     // 返回首页
        //     this.$window.location.href = this.pageContext.rootPath;
        // }

        this.islogin = false;
        // 返回首页
        this.$window.location.href = this.pageContext.rootPath;
    }

    public combineCatalogUrlPath(productCatalogList: productCatalogWithPagePath[]) {
        let pagePathStr: string;
        productCatalogList.forEach(productCatalog => {
            if (productCatalog.parent) {
                let parentCatalogItem = productCatalogList.find((ele) => {
                    if (productCatalog.parent) {
                        return ele.id == productCatalog.parent.id;
                    }
                })
                pagePathStr = productCatalog.catalog.pageName;
                if (parentCatalogItem) {
                    productCatalog.pagePath = parentCatalogItem.catalog.pageName + '/' + pagePathStr;
                }
            } else {
                pagePathStr = productCatalog.catalog.pageName;
                productCatalog.pagePath = pagePathStr + '/all';
            }
        })
        return productCatalogList;
    }

    public fetchProductCatalogData(): void {
        if (this.isFetchedCatalogData) {
            return;
        }
        this.isFetchedCatalogData = true;
        this.productCatalogRestService.getAll()
            .then(res => {
                this.isFetchedCatalogData = true;
                if (!res.data) {
                    window.qpAlertPrompt.warning("Data error", "Can not find product catalog");
                    return;
                }
                //根据产品类目优先级进排序（sortOrder有大到小排列）
                let productCatalogData = res.data;
                productCatalogData = this.$filter('orderBy')(productCatalogData, 'sortOrder', true);
                for (let i = 0; i < productCatalogData.length; i++) {
                    let catalogData = productCatalogData[i];
                    //TODO（待替换为pageNameFilter） pageName去除“.html”
                    catalogData.catalog.pageName = catalogData.catalog.pageName.replace('.html', '');
                }
                this.productCatalogList = this.combineCatalogUrlPath(productCatalogData as unknown as productCatalogWithPagePath[]);
                this.productCatalogList = this.formatArrToTree(this.productCatalogList);
                this.productCatalogList.forEach(productCatalog => {
                    if (productCatalog.children) {
                        productCatalog.expand = false;
                    }
                })
                this.$objectTree.setCache(LocalStorageKeyEnum.CATALOG_LIST, angular.toJson(this.productCatalogList));
                // 查询默认类目
                return DefaultCatalogUtil.getDefaultCatalog(this.$objectTree, this.$q);
            })
            .then((res) => {
                if (res) {
                    this.defaultCatalogUrl = UrlUtil.joinUrl([this.pageContext.rootPath, res.customizePath, (res.defaultCatalog as productCatalogWithPagePath).pagePath]);
                    this.defaultCatalogName = res.defaultCatalog.name;
                    this.$objectTree.setCache(LocalStorageKeyEnum.CATALOG_LIST_EXPIRE, (new Date().getTime() + this.CATALOG_CACHE_TIME).toString());
                }

            })
            .catch(error => {
                this.permissionService.onRequestFail(error);
            })
            .finally(() => {
                this.isFetchedCatalogData = false;
            })
    }

    public formatArrToTree(array) {
        const map = {};
        array.forEach(catalog => {
            map[catalog.id] = catalog;
        });
        const CatalogList = <any>[];
        array.forEach(Catalogitem => {
            if (Catalogitem.parent) {
                if (map[Catalogitem.parent.id]) {
                    if (!map[Catalogitem.parent.id]?.children) {
                        map[Catalogitem.parent.id].children = [Catalogitem];
                    } else if (map[Catalogitem.parent.id]?.children[0].id != Catalogitem.id) {
                        map[Catalogitem.parent.id].children.push(Catalogitem);
                    }
                }
            } else {
                CatalogList.push(Catalogitem);
            }
        });
        return CatalogList
    }


    /**
     * @description 获取页面地址
     * @params pageUrl
     * @param isWebsiteUrl 是否为网站内部地址 true:网站内部地址；false：网站外部地址(暂未弃用)
     * @return url
     * */
    private getUrl(pageUrl: string, isWebsiteUrl?: boolean): string {
        // 校验pageUrl是否为全地址路径
        const http_reg = /^(http|https)/ig;

        // 是否包含域名及应用全路径
        if (http_reg.test(pageUrl)) {
            return pageUrl;
        } else {
            if (isWebsiteUrl) {
                return UrlUtil.joinUrl([this.rootPath, pageUrl]);
            } else {
                // 网站外部地址
                const qpmnDomain = envConfig.getPath("", "");
                return UrlUtil.joinUrl([qpmnDomain, pageUrl]);
            }
        }
    }

    /**
     * @description 打开偏好设置
     */
    public openPreferenceEditor() {
        // do clean post data
        // if (this.$timeout.cancel(this.cleanTimerPromise)) {
        //     this.errorBoxContent = "";
        // };
        this.preferenceEditorService.openPreferenceEditor<ICurrencyObj>(this.$uibModal,
            <PreferenceEditorResolveDefine>{
                selectCurrencyCode: () =>
                    this.preferenceEditorService.userPreference.currencyCode,
                onRequestFailed: () =>
                    this.permissionService.onRequestFailed.bind(this.permissionService),
                savePreference: () =>
                    this.userDataService.updateUserPreference.bind(this.userDataService),
            }, {
            backdrop: false,
            appendTo: angular.element($("nav.drawer-container")),
        }).then((selectedCurrency) => {
            console.log("emit preference", selectedCurrency);
            if (this.preferenceEditorService.diff(selectedCurrency)) {
                console.log("nav emit preference", selectedCurrency);
                this.eventBus.dispatch("UpdateCurrency", selectedCurrency);
            }
        }).catch((reason?: { $message?: string; $reason: string }) => {
            if (!reason || !reason.$message)
                return;
            this.qpMessageDialog.info({
                title: reason.$reason,
                content: reason.$message,
            });
        })
    }
}